module.exports = __webpack_public_path__ + "img/MarcinKondraciuk_140x140_rund.313ad751.jpg";